import { Callback1, StoreObserver, VoidCallback } from '@deqo/foundation';
import { RecordData } from '@deqo/podopolis';
import { PodRecord } from '../../../concepts/objects/RecordSetManager';
import { BindingTarget } from './BindingTarget';

export class PodRecordBindingTarget<T extends RecordData> implements BindingTarget<T> {

    constructor(
        public readonly key: string,
        private readonly record: PodRecord<T>) {
    }

    public mutate(patch: Partial<T>): void {
        this.record.mutate(patch);
    }

    public getState(): Readonly<T> {
        return this.record.getState();
    }

    public observe(observer: StoreObserver<T>): VoidCallback;
    public observe<P>(path: Callback1<P, T>, observer: StoreObserver<P>): VoidCallback;
    public observe(path: any, observer?: any): VoidCallback {
        return this.record.observe(path, observer);
    }
}
